import React from "react";
import { View, Text, TouchableOpacity, TextInput } from "react-native";

// import * as Progress from "react-native-progress";

import LeftArrow from "../../svgs/LeftArrow";
import Close from "../../svgs/Close";
import styles from "./style";

export default function Header({ isFirstStep, onActionPressed, progress }) {
  return (
    <View>
      <View style={styles.header}>
        <TouchableOpacity
          onPress={() => onActionPressed(false)}
          style={styles.icon}
        >
          <LeftArrow width="25" height="25" />
        </TouchableOpacity>

        <Text style={styles.title}>Cadastro</Text>

        <TouchableOpacity
          onPress={() => onActionPressed(true)}
          style={styles.icon}
        >
          {isFirstStep() ? null : <Close width="25" height="25" />}
        </TouchableOpacity>
      </View>

      {/* <Progress.Bar
        width={null}
        color="#1FBFB5"
        borderRadius={0}
        progress={progress}
        borderColor="transparent"
      /> */}
    </View>
  );
}